import axios from "axios";
import { buildAuthHeaders } from "../buildAuthHeaders";
import { rootUrl } from "../rootUrl";

export type ContactTimelineData = {
  date: string;
  count: number;
};

export type GetContactTimelineResponse = {
  timeline: ContactTimelineData[];
};

const endpoint = `/client/contact-analytics`;

export const getContactTimeline = async (
  accessToken: string,
  timeFrame: "day" | "month" | "year"
): Promise<GetContactTimelineResponse> => {
  const { data } = await axios.get<GetContactTimelineResponse>(
    `${rootUrl}${endpoint}?timeFrame=${timeFrame}`,
    buildAuthHeaders(accessToken)
  );
  return data;
};
